import { BehaviorSubject } from 'rxjs';
import Color from '@base/features/game/model/color';

export type DiceObservable = {
  availableMoves: number[];
  consumedMoves: number[];
  firstValue: number;
  secondValue: number;
  color: Color;
  withRoll: boolean;
};

export default class Dice {
  /**
   * Изменилось значение Dices
   * @event onDicesChanged
   * @param {Object} dice consumedMoves, availableMoves
   */
  rolling = new BehaviorSubject(false);

  availableMoves: number[] = [];
  consumedMoves: number[] = [];
  firstValue = 6;
  secondValue = 6;
  onDiceChangedEvent = new BehaviorSubject<DiceObservable>({
    availableMoves: this.availableMoves,
    consumedMoves: this.consumedMoves,
    firstValue: this.firstValue,
    secondValue: this.secondValue,
    color: Color.Black,
    withRoll: this.rolling.value,
  });

  constructor(private gameState: any) {}

  addValueToAvailableMoves(value: number) {
    if (value === 0) {
      return;
    }
    if (value > 0) {
      this.availableMoves.push(value);
    } else {
      this.consumedMoves.push(-value);
    }
    this.emitDicesChanged();
  }

  setValues(firstValue: number, secondValue: number, newScore?: boolean) {
    this.clearValues();
    this.firstValue = firstValue;
    this.secondValue = secondValue;
    if (firstValue === secondValue && firstValue !== -1) {
      for (let i = 0; i < 4; i++) {
        this.availableMoves.push(firstValue);
      }
    } else {
      this.addValueToAvailableMoves(firstValue);
      this.addValueToAvailableMoves(secondValue);
    }
    if (newScore) {
      this.emitStartRoll();
      setTimeout(() => this.emitEndRoll(), 800);
    }
    this.emitDicesChanged(newScore);
  }

  setValuesFromArray(values: number[]) {
    this.clearValues();

    for (let i = 0; i < values.length; i++) {
      this.addValueToAvailableMoves(values[i]);
    }

    this.firstValue = Math.abs(values[0]);
    this.secondValue = Math.abs(values[1]);
    this.emitDicesChanged();
  }

  getAvailableMoves() {
    //return copy of array
    return this.availableMoves.slice();
  }

  getConsumedMoves() {
    //return copy of array
    return this.consumedMoves.slice();
  }

  getFirstValue() {
    return this.firstValue;
  }

  getSecondValue() {
    return this.secondValue;
  }

  consumeTurn(turn: number) {
    for (let i = 0; i < this.availableMoves.length; i++) {
      if (this.availableMoves[i] === turn) {
        this.availableMoves.splice(i, 1);
        this.consumedMoves.push(turn);
        this.emitDicesChanged();
        return true;
      }
    }
    return false;
  }

  undoTurn(turn: number) {
    turn = Math.abs(turn);

    for (let i = 0; i < this.consumedMoves.length; i++) {
      if (this.consumedMoves[i] === turn) {
        this.consumedMoves.splice(i, 1);
        this.availableMoves.push(turn);
        this.emitDicesChanged();
        return;
      }
    }
    throw new Error('can`t undo turn, can`t find turn in consumed moves');
  }

  containsAvaialableMove(turn: number) {
    for (let i = 0; i < this.availableMoves.length; i++) {
      if (this.availableMoves[i] === turn) return true;
    }
    return false;
  }

  containsConsumedMove(turn: number) {
    for (let i = 0; i < this.consumedMoves.length; i++) {
      if (this.consumedMoves[i] === turn) return true;
    }
    return false;
  }

  toString() {
    let result = '';
    result += 'consumedMoves';
    for (let i = 0; i < this.consumedMoves.length; i++) {
      result += this.consumedMoves[i].toString() + ' ';
    }

    result += 'availableMoves';
    for (let i = 0; i < this.availableMoves.length; i++) {
      result += this.availableMoves[i].toString() + ' ';
    }

    return result;
  }

  clearValues() {
    while (this.availableMoves.length) {
      this.availableMoves.pop();
    }
    while (this.consumedMoves.length) {
      this.consumedMoves.pop();
    }
  }

  emitDicesChanged(withRoll?: boolean) {
    const dices: DiceObservable = {
      availableMoves: this.getAvailableMoves(),
      consumedMoves: this.getConsumedMoves(),
      firstValue: this.getFirstValue(),
      secondValue: this.getSecondValue(),
      color: this.gameState.getCurrentTurn(),
      withRoll: Boolean(withRoll),
    };

    this.onDiceChangedEvent.next(dices);
  }

  emitStartRoll() {
    this.rolling.next(true);
  }

  emitEndRoll() {
    this.rolling.next(false);
  }
}
